(function () {
  if (window.__sfcInit) return; window.__sfcInit = true;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const root = $('[data-sfc]');
  if (!root) return;
  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const NB = String.fromCharCode(160);
  const euro = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + NB + '€';
  let meta = { cmp: {}, packs: {} };
  try { meta = JSON.parse(root.dataset.meta || '{}'); } catch (e) {}
  const cmp = meta.cmp || {}, packs = meta.packs || {};
  const th = +root.dataset.threshold || 0;
  const fee = +root.dataset.shipFee || 0;
  const giftPid = root.dataset.giftProductId || '', giftVid = +root.dataset.giftVariant || 0;
  const esc = (t) => String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  let busy = false;

  const api = (url, body) => fetch(base + url, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; });

  const showError = (m) => { const e = $('[data-sfc-error]', root); if (e) { e.hidden = !m; e.textContent = m || ''; } };
  const isGift = (it) => giftPid && String(it.product_id) === giftPid;
  const upPid = root.dataset.upProductId || '', upVid = +root.dataset.upsellVariant || 0; const isAddon = (it) => (upPid && String(it.product_id) === upPid) || (upVid && it.variant_id === upVid); const syncAddon = (c) => { const addons = c.items.filter(isAddon); const hasMain = c.items.some((i) => !isGift(i) && !isAddon(i)); if (!addons.length || hasMain || busy) return false; const upd = {}; addons.forEach((a) => { upd[a.variant_id] = 0; }); busy = true; api('cart/update.js', { updates: upd }).catch(() => {}).finally(() => { busy = false; refresh(); }); return true; };

  const lineHtml = (it) => {
    const pid = String(it.product_id);
    if (isGift(it)) {
      const gimg = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
      return '<div class="sfc__line sfc__line--gift" data-key="' + esc(it.key) + '">'
        + '<div class="sfc__img">' + (gimg ? '<img src="' + esc(gimg) + '" alt="">' : '') + '</div>'
        + '<div class="sfc__info">'
        + '<div class="sfc__row"><a class="sfc__title" href="' + esc(root.dataset.giftUrl || '#') + '">' + esc(it.product_title) + '</a>'
        + '<div class="sfc__price"><b>Gratis</b></div></div>'
        + '<div class="sfc__gift">' + esc(root.dataset.txtGiftNote || '') + '</div>'
        + '</div></div>';
    }
    const img = (pid === root.dataset.productId || pid === root.dataset.upProductId) && root.dataset.lineImage
      ? root.dataset.lineImage
      : (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '');
    const was = cmp[String(it.variant_id)] ? cmp[String(it.variant_id)] * it.quantity : 0;
    const old = Math.max(was, it.original_line_price);
    const variant = it.variant_title && it.variant_title !== 'Default Title' ? 'Auswahl: ' + esc(it.variant_title) : '';
    const gift = root.dataset.txtGift && (pid === root.dataset.productId || pid === root.dataset.upProductId) ? esc(root.dataset.txtGift) : '';
    return '<div class="sfc__line" data-key="' + esc(it.key) + '">'
      + '<div class="sfc__img">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</div>'
      + '<div class="sfc__info">'
      + '<div class="sfc__row"><div class="sfc__title">' + esc(it.product_title) + '</div>'
      + '<div class="sfc__price"><b>' + euro(it.final_line_price) + '</b>' + (old > it.final_line_price ? '<s>' + euro(old) + '</s>' : '') + '</div></div>'
      + (variant ? '<div class="sfc__variant">' + variant + '</div>' : '')
      + (gift ? '<div class="sfc__gift">' + gift + '</div>' : '')
      + '<div class="sfc__ctl"><div class="sfc__qty"><button type="button" data-q="-1" aria-label="weniger">&minus;</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="mehr">+</button></div>'
      + '<button type="button" class="sfc__rm" data-remove aria-label="Entfernen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M9 7V4.5h6V7"/><path d="M6 7l1 13h10l1-13"/><path d="M10 11v6M14 11v6"/></svg></button></div>'
      + '</div></div>';
  };

  // Gratis-Training automatisch zur Bestellung legen / entfernen
  const syncGift = (c) => {
    if (!giftVid || busy) return;
    const hasMain = c.items.some((i) => !isGift(i));
    const gl = c.items.find(isGift);
    if (hasMain && !gl) {
      busy = true;
      api('cart/add.js', { items: [{ id: giftVid, quantity: 1 }] }).then(refresh).catch(() => {}).finally(() => { busy = false; });
    } else if (!hasMain && gl) {
      busy = true;
      api('cart/change.js', { id: gl.key, quantity: 0 }).then(renderCart).catch(() => {}).finally(() => { busy = false; });
    } else if (gl && gl.quantity > 1) {
      busy = true;
      api('cart/change.js', { id: gl.key, quantity: 1 }).then(renderCart).catch(() => {}).finally(() => { busy = false; });
    }
  };

  const renderCart = (c) => {
    const real = c.items.filter((i) => !isGift(i));
    const count = real.reduce((s, i) => s + i.quantity, 0);
    $$('[data-cart-count]').forEach((n) => { n.textContent = count; n.hidden = count === 0; });
    const bottles = real.reduce((s, it) => s + it.quantity * (packs[String(it.variant_id)] || 1), 0);
    $('[data-sfc-count]', root).textContent = bottles;
    root.classList.toggle('is-empty', count === 0);
    $('[data-sfc-items]', root).innerHTML = c.items.map(lineHtml).join('');
    $('[data-sfc-empty]', root).hidden = count > 0;
    $('[data-sfc-total]', root).textContent = euro(c.total_price);

    const free = th > 0 && c.total_price >= th;
    const tax = $('[data-sfc-tax]', root);
    if (tax) tax.textContent = !th || free ? root.dataset.txtTaxFree : root.dataset.txtTaxFee.replace('{fee}', euro(fee));
    const txt = $('[data-sfc-ship-text]', root), bar = $('[data-sfc-ship-bar]', root);
    if (th > 0 && txt && bar) {
      txt.innerHTML = free ? root.dataset.txtDone : root.dataset.txtMore.replace('Noch {amount}', '<strong class="sfc__hl">Noch ' + euro(th - c.total_price) + '</strong>').replace('{amount}', euro(th - c.total_price));
      bar.style.width = Math.min(100, (c.total_price / th) * 100) + '%';
    }

    const up = $('[data-sfc-up]', root);
    if (up) {
      const first = root.dataset.firstVariant, upv = root.dataset.upsellVariant, upp = root.dataset.upProductId;
      const hasFirst = c.items.some((i) => String(i.variant_id) === first);
      const hasUp = c.items.some((i) => String(i.variant_id) === upv || String(i.product_id) === upp);
      up.hidden = !(hasFirst && !hasUp && upv);
    }
    if (!syncAddon(c)) syncGift(c);
  };

  const refresh = () => api('cart.js').then(renderCart);
  const openCart = () => { root.hidden = false; document.body.classList.add('sf-lock'); };
  const closeCart = () => { root.hidden = true; document.body.classList.remove('sf-lock'); };

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-sfc-close]')) { closeCart(); return; }
    const line = e.target.closest('.sfc__line');
    if (line) {
      const qb = e.target.closest('[data-q]');
      const rm = e.target.closest('[data-remove]');
      if (!qb && !rm) return;
      let q = +$('.sfc__qty span', line).textContent;
      q = rm ? 0 : q + +qb.dataset.q;
      api('cart/change.js', { id: line.dataset.key, quantity: Math.max(0, q) }).then(renderCart).catch((er) => showError(er.message));
      return;
    }
    const add = e.target.closest('[data-sfc-add]');
    if (add) {
      add.disabled = true; showError('');
      api('cart/add.js', { items: [{ id: +root.dataset.upsellVariant, quantity: 1 }] })
        .then(refresh).catch((er) => showError(er.message)).finally(() => { add.disabled = false; });
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) closeCart(); });
  $$('#sf-cart-icon, a[href$="/cart"]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); refresh().then(openCart); }));

  $$('[data-sf-form]').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = $('[data-sf-atc]', f); btn.disabled = true; showError('');
    api('cart/add.js', { items: [{ id: +$('input[name="id"]', f).value, quantity: 1 }] })
      .then(refresh).then(openCart).catch((er) => { showError(er.message); openCart(); })
      .finally(() => { btn.disabled = false; });
  }));
})();